const setHighlight = (editor, { value: color }) => {
  editor.chain().focus().setHighlight({ color }).run();
};

const unsetHighlight = (editor) => {
  editor.chain().focus().unsetHighlight().run();
};

export default {
  'highlight:set': setHighlight,
  'highlight:unset': unsetHighlight,
};
